import { createTransform } from 'redux-persist';

import { UserTypes } from '../../constants';

/**
 * Restore `userType` to the UserTypes constant on rehydrate.
 *
 * The auth reducer stores the constant itself, and the app compares against it
 * by reference (`userType === UserTypes.SUPER`). Persisting serialises it to a
 * plain `{ name, index }` object, so without this every such check failed after
 * a page reload — for a Super user, the Network screen redirected away and the
 * Super-only tabs disappeared.
 */
const AuthTransform = createTransform(
  (inboundState) => inboundState,
  (outboundState) => ({
    ...outboundState,
    userType: outboundState.userType == null
      ? null
      : Object.values(UserTypes).find((type) => type.name === outboundState.userType.name) ?? null
  }),
  { whitelist: ['auth'] }
);

export default AuthTransform;
